<!-- Nav Menu -->

<template>
  <div>
    <template v-if="$route.name == 'home'">
      <div id="app" :style="{ backgroundImage: 'url(' + takeover + ')' }" :class="{parallax: takeover !== ''}" class="overflowAll">
        <Menu
          @season="setSeason"
          @course="setCourse"
          @report="setReport"
          @title="setTitle"
          :config="env"
        />
        <transition name="fade" appear>
          <router-view
            :key="$route.fullPath"
            :season="season"
            :course="course"
            :report="report"
            :title="title"
            @takeover="setTakeOver"
            :config="env"
        /></transition>
        <CookieBanner />
        <Footer :season="season" :config="env"/>
      </div>
    </template>
    <template v-else>
      <div id="app" class="overflowAll">
        <Menu
         @season="setSeason"
          @course="setCourse"
          @report="setReport"
          @title="setTitle"
          :config="env"
        />
        <transition name="fade" appear>
          <router-view
            :key="$route.fullPath"
            :season="season"
            :course="course"
            :report="report"
            @takeover="setTakeOver"
            :config="env"
        /></transition>
        <CookieBanner />
        <Footer :season="season" :config="env"/>
      </div>
    </template>
  </div>
</template>


<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  font-family: "oswald", Helvetica, Arial !important;
  font-size: 14pt;
}
li.nav-item::marker {
  color: transparent;
}
.parallax{
  min-height: 500px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media only screen and (max-width: 768px) {
  .overflowAll {
    overflow: hidden;
  }
}
@media only screen and (max-width: 480px) {
  #app {
    font-size: 10pt;
  }
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #1f1f1f;
  color: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  animation: cookieSlideUp .35s ease;
}

.cookie-banner p {
  margin: 0;
  line-height: 1.6;
  font-size: 15px;
  flex: 1;
}

.cookie-banner .buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-banner button {
  border: none;
  border-radius: 8px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s ease;
}

.cookie-banner button:first-of-type {
  background: transparent;
  border: 1px solid #666;
  color: #fff;
}

.cookie-banner button:first-of-type:hover {
  background: #333;
}

.cookie-banner button:last-of-type {
  background: #00a651;
  color: #fff;
}

.cookie-banner button:last-of-type:hover {
  background: #008d45;
  transform: translateY(-1px);
}

@keyframes cookieSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner .buttons {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner button {
    width: 100%;
  }
}
</style>
<script>
  <meta name="apple-itunes-app" content="app-id=419334047"></meta>
</script>
<script>
import Footer from "@/components/footer.vue";
import Menu from "@/components/menu.vue";
import CookieBanner from "@/components/CookieBanner.vue";
export default {
  components: {
    Footer,
    Menu,
    CookieBanner
  },
  data() {
    return {
      season: "",
      report: "",
      course: "",
      title:'',
      takeover:'',
      env:[]
    };
  },
  methods: {
    // Define method that will use the payload to update the data property
    setCourse(payload) {
      this.course = payload.course;
    },
    setSeason(payload) {
      this.season = payload.season;
    },
    setReport(payload) {
      this.report = payload.report;
    },
    setTitle(payload) {
      this.title = payload.title;
    },
    setTakeOver(payload) {
      this.takeover = payload.takeover;
    },
  },
  mounted(){
    this.env = process.env
  }
};
</script>
